import { useCallback, useEffect, useState } from 'react';

export function getScheduleCommandPrompt(value) {
  const command = String(value || '').trim().toLowerCase();
  return !!command && '/schedule'.startsWith(command);
}

export default function useScheduleCommand({ value, contextId, enabled, onSelect }) {
  const [dismissed, setDismissed] = useState(null);
  useEffect(() => setDismissed(null), [value, contextId]);
  const prompt = enabled && getScheduleCommandPrompt(value)
    && !(dismissed?.value === value && dismissed?.contextId === contextId);
  const dismiss = useCallback(() => setDismissed({ value, contextId }), [value, contextId]);
  const select = useCallback(() => { if (enabled) return onSelect(); }, [enabled, onSelect]);
  const onKeyPress = useCallback(event => {
    if (!prompt || event.isComposing || event.nativeEvent?.isComposing) return false;
    const key = event.key || event.nativeEvent?.key;
    if (key !== 'Escape' && (key !== 'Tab' || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey)) return false;
    event.preventDefault?.();
    event.stopPropagation?.();
    if (key === 'Escape') dismiss();
    else select();
    return true;
  }, [prompt, dismiss, select]);
  return { prompt, select, dismiss, onKeyPress };
}
